<template>
  <div></div>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    callback: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    }
  },
}
</script>

<style lang="scss" scoped>

</style>